import styled from 'styled-components';

const WizardStep = styled.div<{ $active: boolean }>`
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background-color: ${({ $active, theme }) => theme.getColor($active ? 'blue400' : 'gray200')};
  display: inline-block;
  margin-right: 5px;
`;

export const S = {
  WizardStep,
};
